<template>
	<div class="clients-manager">
		<vx-card class="my-8">
			<vs-tabs v-if="tabs.length > 0" @setActiveTab="setActiveTab">
				<vs-tab
					v-for="tab in tabs"
					:key="tab.title"
					:value="indexTab"
					:counter="getTabCounter(currentPageList)"
					:label="$t(tab.title)"
				>
					<div class="vx-row justify-between">
						<div class="vx-col">
						  <div class="perPage">
							<v-select
							  v-model="select1"
							  :searchable="false"
							  :options="[10,20,50]"
							  class="selectExample clientsm-pages-amount w-full"
							/>
						  </div>
						</div>
<!--						<div class="vx-col w-2/3 sm:w-1/3 lg:w-1/5">-->
<!--							<vs-input-->
<!--								v-model="searchName"-->
<!--								@input="filterTable"-->
<!--								:placeholder="$t('search') + '...'"-->
<!--								class="w-full"-->
<!--							></vs-input>-->
<!--						</div>-->
					</div>

					<div class="tab-text ">
						<vs-table
							:max-items="select1"
							pagination
							:data="currentPageList"
							:sst="true"
							@change-page="setPageNumber"
							:currentPage="currentPage"
							:total="totalClients"
						>
							<template slot="thead">
								<vs-th
									v-for="fil in field" :style="'width:' +fil.width"
									:class="{
								'justify-center': fil.align && fil.align === 'center',
								'text-center': fil.align && fil.align === 'center'
							}"
								>
                  {{ $capitalizeFirstLetter($t(fil.title)) }}
								</vs-th>
							</template>

							<template slot-scope="{ data }">
								<vs-tr class="vs-table-filters">
									<template v-for="fil in field">
										<vs-td v-if="fil.field === 'name'">
											<vs-input class="w-full" v-model="searchName"
													  @input="filterTable"></vs-input>
										</vs-td>
										<vs-td v-else-if="fil.field === 'email'">
											<vs-input class="w-full" v-model="searchEmail"
													  @input="filterTable"></vs-input>
										</vs-td>
										<vs-td v-else-if="fil.field === 'phone'">
											<vs-input class="w-full" v-model="searchPhone"
													  @input="filterTable"></vs-input>
										</vs-td>
										<vs-td v-else-if="fil.field === 'current_manager'">
											<v-select
												v-model="searchManager"
												:reduce="item => item.id"
												@input="filterTable"
												:options="filteredManagers"
												label="full_name"
												class="w-max"
											/>
										</vs-td>
										<vs-td v-else-if="fil.field === 'chat_messages_count'">
											<v-select
												v-model="searchUnread"
												:reduce="item => item.value"
												@input="filterTable"
												:options="unreadSelect"
												label="name"
												class="w-full"
											/>
										</vs-td>
										<vs-td v-else></vs-td>
									</template>
								</vs-tr>

								<vs-tr :key="indextr" v-for="(tr, indextr) in data">
									<template v-for="fil in field">
										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
											   v-if="fil.field === 'name'">
											<router-link :to="'clientM/' + tr.id">
												{{ getClientName(tr.first_name, tr.last_name) }}
											</router-link>
										</vs-td>

										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
											   v-else-if="fil.field === 'client.username'">
											<!--											<router-link :to="'client/' + deepFind(tr, 'client.id')">-->
											<router-link to="/">
												{{ deepFind(tr, fil.field) }}
											</router-link>
										</vs-td>

										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
											   v-else-if="fil.field === 'author.username'">
											<router-link v-if="tr[fil.field]"
														 :to="'client/' + deepFind(tr, 'author.id')">
												{{ deepFind(tr, fil.field) }}
											</router-link>
										</vs-td>

										<vs-td
											v-else-if="fil.field === 'chat_messages_count'"
											:class="{'text-center': fil.align && fil.align === 'center'}"
										>
											<div class="flex justify-center">
											<span
												class="counter"
												:class="{ warn: tr.has_new_message }"
											>
												{{ tr.chat_messages_count }}
											</span>
											</div>
										</vs-td>

										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
											   v-else-if="fil.field === 'subject'">
											{{
												$getDeep(tr.subject, subjects)
											}}
										</vs-td>
										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
											   v-else-if="fil.field === 'work_type'">
											{{
												$getDeep(tr.work_type, works)
											}}
										</vs-td>
										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
											   v-else-if="fil.field === 'quality_level'">
											{{
												$getDeep(tr.quality_level, levels)
											}}
										</vs-td>
<!--										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"-->
<!--											   v-else-if="fil.field === 'gender'">-->
<!--											{{-->
<!--												$getDeep(tr.gender, genders)-->
<!--											}}-->
<!--										</vs-td>-->
<!--										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"-->
<!--											   v-else-if="fil.field === 'country'">-->
<!--											{{-->
<!--												$getDeep(tr.country, countries)-->
<!--											}}-->
<!--										</vs-td>-->
										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
											   v-else-if="fil.field === 'current_manager'">
											{{
												getManagerName(tr.manager)
											}}
										</vs-td>
										<vs-td :class="{'text-center': fil.align && fil.align === 'center', disabled: !checkIfCurrentManager(tr.manager)}"
											   v-else-if="fil.field === 'task'">
											<!--									<span -->
											<!--										v-if="tr[fil.field]"-->
											<!--										@click="getTask(tr)"-->
											<!--										class="task" -->
											<!--									>{{ tr[fil.field].date_time | moment('DD.MM.YYYY') }}</span>-->
											<!--									<span -->
											<!--										v-else-->
											<!--										@click="idOrder = tr.id;activePrompt = true" -->
											<!--										class="task" -->
											<!--									>+</span>-->

											<span
												v-if="tr[fil.field]"
												@click="getTask(tr)"
												class="task cursor-pointer"
											>{{ tr[fil.field].date_time | moment('DD.MM.YYYY') }}</span>

											<span
												v-else
												@click="createTask(tr)"
												class="task cursor-pointer"
											>+</span>
										</vs-td>
										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
											   v-else-if="fil.field === 'price'">
											{{ tr[fil.field] }}
										</vs-td>
										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
											   v-else-if="fil.field === 'is_enabled_for_junior'">
											{{ tr[fil.field] ? $t('yes') : $t('no') }}
										</vs-td>
										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
											   v-else-if="fil.field === 'actions'">
											<div
												class="flex justify-center chat"
												@click="$store.dispatch('getMessages',{userId: tr.id}); $router.push({ query: { userId: tr.id } })"
											  >
												<vs-custom-button
													size="small"
													color="#626262"
													type="flat"
													icon-pack="feather"
													icon="edit"
												>
													<feather-icon icon="MessageSquareIcon"></feather-icon>
												</vs-custom-button>

												<span
													v-if="tr.sendpulse_unsubscribed"
													class="cursor-pointer ml-2 pt-2"
													title="Client unsubscribed from sendpulse"
												>
													<vs-icon icon="cancel_schedule_send" size="small" color="red"></vs-icon>
												</span>
												<span
													v-if="tr.mailjet_unsubscribed"
													class="cursor-pointer ml-2 pt-2"
													title="Client unsubscribed from Mailjet"
												>
													<vs-icon icon="cancel_schedule_send" size="small" color="orange"></vs-icon>
												</span>
												<span
													v-if="!tr.sendpulse_unsubscribed && !tr.mailjet_unsubscribed"
													class="pl-2 pr-2 ml-2 mr-2"
												></span>
											</div>
										</vs-td>
										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
											   v-else-if="tr[fil.field] || tr[fil.field] === 0">
											{{ tr[fil.field] }}
										</vs-td>
										<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else>
											---
										</vs-td>
									</template>
									<template v-if="userRole === 'manager'">
										<vs-td v-if="tab.key === 'clients'">
											<span
												class="delete-action cursor-pointer text-danger"
                        :class="{disabled: !checkIfCurrentManager(tr.manager)}"
												@click="blockUser(tr)"
											>
												<feather-icon badge size="1.5x" icon="Trash2Icon"></feather-icon>
											</span>

										</vs-td>
										<vs-td v-else-if="tab.key === 'ban_clients'">
										<span
											class="delete-action d-flex cursor-pointer text-success"
                      :class="{disabled: !checkIfCurrentManager(tr.manager)}"
											@click="unblockUser(tr)"
										>
											<feather-icon badge size="1.5x" icon="Trash2Icon"></feather-icon>
										</span>

										</vs-td>
									</template>
								</vs-tr>
							</template>
						</vs-table>
					</div>
				</vs-tab>
			</vs-tabs>
		</vx-card>
		<AddOrderTask
			:active.sync="addTaskPopup"
			:order="selectedOrder"
			mode="client"
		/>
		<ViewOrderTask
			:active.sync="viewTaskPopup"
			:order="selectedOrder"
			mode="client"
		/>
	</div>
</template>

<script>
import AddOrderTask from "@/components/dialogs/AddOrderTask";
import ViewOrderTask from "@/components/dialogs/ViewOrderTask";
import vSelect from 'vue-select'
import datepicker from 'vuejs-datepicker'
import debounce from 'debounce'
import notifier from "@/mixins/notifier";
import clientsHeaders from "@/assets/configs/clientsHeaders";
import databaseManager from "@/mixins/databaseManager";

export default {
	name: "typeWorks",
	mixins: [notifier, databaseManager],
	components: {
		AddOrderTask,
		ViewOrderTask,
		'v-select': vSelect,
		datepicker
	},
	data() {
		return {
			about: '',
			date: '',
			searchName: '',
			searchEmail: '',
			searchPhone: '',
			searchManager: '',
			searchUnread: '',

			currentPage: 1,
			totalClients: 1,

			select1: 10,
			nameRu: '',
			nameDe: '',
			price: '',
			juniorIs: false,

			indexTab: 0,
			tabs: [],
			tabsHasMessageSet: new WeakSet(),

			addTaskPopup: false,
			viewTaskPopup: false,
			selectedOrder: null,
			subjects: [],
			// works: {
			// 	clients: [],
			// 	ban_clients: [],
			// },
			clients: [],
			ban_clients: [],
			countries: [],
			genders: [],
			editModel: {},
			task: {},
			managers: [],

		};
	},
	methods: {
		async setPageNumber(data) {
			this.currentPage = data;
			await this.getWorks()
		},
		async setActiveTab(data) {
			const prev = this.indexTab;
			this.indexTab = data;
			if (prev === 0 && this.indexTab < 1) return;
			this.currentPage = 1;
			await this.getWorks()
		},
		unblockUser(user){
			this.$vs.dialog({
				color: "success",
				title: this.$t(`confirmUnblockingUser`),
				acceptText: this.$t(`confirm`),
				cancelText: this.$t(`doCancel`),
				text: `${this.$t('confirmUnblocking')} "${user.first_name || ''} ${user.last_name || ''}"`,
				accept: async () => {
					try {
						const response = (await this.$http.post(
							`/manager/client/activate/${user.id}`
						)).data;
						if(response.status === 200){
							this.notifySuccess(this.$t('user_unbanned_successfully'));
							await this.getWorks();
						}else{
							throw new Error('Something went wrong')
						}
					} catch (e) {
						this.notifyError(e.message);
					}
				}
			})
		},
		blockUser(user){
			this.$vs.dialog({
				color: "danger",
				title: this.$t(`confirmBlockingUser`),
				acceptText: this.$t(`confirm`),
				cancelText: this.$t(`doCancel`),
				text: `${this.$t('confirmBlocking')} "${user.first_name || ''} ${user.last_name || ''}"`,
				accept: async () => {
					try {
						const response = (await this.$http.post(
							`/manager/client/ban/${user.id}`
						)).data;
						if(response.status === 200){
							this.notifySuccess(this.$t('user_banned_successfully'));
							await this.getWorks();
						}else{
							throw new Error('Something went wrong')
						}
					} catch (e) {
						this.notifyError(e.message);
					}
				}
			})
		},
		getTabCounter(works) {
			return {
				value: works.length,
				color: this.tabsHasMessageSet.has(works) ? "orange" : undefined
			};
		},
		getClientName(firstName, lastName) {
			const fullName = [firstName, lastName].join(" ");
			return fullName !== " " ? fullName : "---";
		},
		filterTable: debounce(function (e) {
			// let options = '?';
			// if (this.searchName.length > 0) options += 'filter[name]=' + this.searchName + '&'
			// if (this.searchEmail.length > 0) options += 'filter[email]=' + this.searchEmail + '&'
			// if (this.searchPhone.length > 0) options += 'filter[phone]=' + this.searchPhone
			let item = this.tabs[this.indexTab];
			item.key === 'clients'
				? this.clients = []
				: this.ban_clients = [];

      this.currentPage = 1
			this.getWorks();
		}, 500),
		async removeTask() {
			try {

				await this.$http.post("/manager/task/delete/" + this.editModel.id);

				this.notifySuccess(this.$t('deletedSuccessfully'));
				this.editModel = {};
				this.getWorks();

			} catch (e) {
				this.notifyError(e.message);
			}
		},
		createTask(order) {
			this.selectedOrder = order;
			this.addTaskPopup = true;
		},
		async getTask(order) {
			this.selectedOrder = order;
			this.viewTaskPopup = true;
		},
		deepFind(obj, path) {
			if (!path) return "";
			let paths = path.split("."),
				current = obj,
				i;

			for (i = 0; i < paths.length; ++i) {
				if (current[paths[i]] === undefined) {
					return undefined;
				} else {
					current = current[paths[i]];
				}
			}
			return current;
		},
		// async getWorks(options = '') {
		// 	for (let item of this.tabs) {
		// 		if(item.key === "ban_clients"){
		// 			options += (options ? '&' : '?') + 'tab=ban';
		// 		}
		// 		try {
		// 			let url = options ? "/manager/client" + options : "/manager/client";
		// 			const res = (await this.$http.get(url)).data.data;
		// 			this.works[item.key] = res || [];
		// 		} catch (e) {
		// 			this.notifyError(e.message);
		// 		}
		// 	}
		// },
		async getWorks() {
			let options = {
				name: this.searchName,
				email: this.searchEmail,
				phone: this.searchPhone,
				current_manager: this.searchManager,
				unread_messages_count: this.searchUnread,


			}
			let item = this.tabs[this.indexTab];
			const offset = (this.currentPage - 1) * this.select1;
			let tab;
			item.title === "ban_clients" ? tab = 'ban' : tab = '';

			const clientsList = this.currentPageList;

			let reqOptions = {
				...options,
				tab: tab,
				limit: this.select1,
				offset: offset
			}

			try {
				const res = await this.dbGetClientsList(reqOptions);
				this.totalClients = res.count;
				if (res.data === null) return;
				// this.totalClients = 14;

				for (let i = 0; i < offset; i++) {
					this.$set(clientsList, i, res.data[0])
				}

				for (let i = 0; i < res.data.length; i++) {
					this.$set(clientsList, offset + i, res.data[i])
				}

			} catch (e) {
				this.$vs.notify({
					title: "Error",
					text: e.message,
					iconPack: "feather",
					icon: "icon-alert-circle",
					color: "danger",
				});
			}

		},

    checkIfCurrentManager(manager) {
      if (manager) {
        return manager.id === this.currentManagerId
      }
      return true
    },

    getManagerName(manager) {
      if (manager) return manager.name
      return '---'
    }
	},
	computed: {
		unreadSelect() {
			return [
				{
					name: this.$t('unread'),
					value: 0,
				},
				{
					name: this.$t('read'),
					value: 1,
				},

			];
		},
		userRole() {
			return this.$store.state.auth.role;
		},
		currentPageList() {
			let item = this.tabs[this.indexTab];
			return item.key === 'clients'
				? this.clients
				: this.ban_clients;
		},
		currentManagerId() {
		  if (this.userRole) {
			return this.$store.state.auth.user.id
		  }
		  return null
		},
		filteredManagers() {
			if (!this.managers || !this.managers.length) return [];
			return this.managers.map((el) => ({
				...el,
				full_name: `${el.first_name || ''} ${el.last_name || ''}`.trim() || `#${el.id}`,
			}));
		},
	},
	watch: {
		select1(newVal) {
			if (newVal) {
				this.getWorks();
			}
		}
	},
	created() {
		const headers = clientsHeaders.getHeaders(this.userRole);
		this.field = headers.field;
		this.tabs = headers.tabs;
	},
	async mounted() {
		this.getWorks();
		this.managers = (await this.dbGetMangers()) || [];
		this.genders = (await this.$http.get("/settings/get-genders")).data.data;
		this.countries = (await this.$http.get("/settings/get-countries")).data.data;
	},
};
</script>

<style lang="scss">
@import "../../assets/scss/vuexy/variables";
@import "../../assets/scss/vuexy/functions";

.vs__dropdown-menu {
  min-width: fit-content;
}

.clients-manager {
	.buttons {
		justify-content: flex-end;
	}

	.button-task {
		border-radius: 22px;
		padding: 0.25rem 0.7rem !important;
	}

	.vs--single.vs--open .vs__selected {
		position: initial;
	}

	th.text-center {
		& > .vs-table-text {
			text-align: center;
		}
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.5s;
	}

	.perPage {
		width: 65px;
    flex: 0 0 auto;

		.vs__dropdown-toggle {
			border-radius: 100px;
			padding: 0;
		}

		.vs__clear {
			display: none;
		}
		.vs__selected-options {
			padding-left: 13px;
		}

		.vs__search {
		  padding: 0;
		}

		.vs__selected-options {
			.vs__selected {
				padding: 0;
				flex: 0 0 auto;
				padding: 0;
			}
			flex-wrap: nowrap;
		}
	}

	.inputInTable {
		border: 0;
		resize: none;
	}

	.fade-enter, .fade-leave-to {
		opacity: 0;
	}

	.buttons {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		@media screen and (max-width: 375px) {
			button {
				margin: 5px 0;
			}
		}
	}

	.justify-center .vs-table-text {
		justify-content: center;
	}

	.vs-checkbox-default {
		flex-shrink: 0;
	}

	.vs-tabs--content {
		padding: 0;
		margin-top: 10px;
	}

	.vs-con-table .vs-con-tbody {
		border: 0;
		background-color: transparent;
	}

	.vs-table {
		margin-top: 10px;

		tr {
			border-top: 1px solid #cfcfcf;

			&:last-child {
				border-bottom: 1px solid #cfcfcf;
			}
		}
	}

	.con-vs-tabs .con-slot-tabs {
		overflow: visible;
	}

	.task {
		background-color: #3ac47d;
		border-radius: 10px;
		padding: 4px 10px;
		color: white;
	}

	.counter {
		display: inline-block;
		padding: 5px;
		border-radius: 100%;
		font-weight: 600;
		width: 20px;
		height: 20px;
		font-size: 0.7rem;
		border: 1px solid #cfcfcf;
		display: flex;
		align-items: center;
		justify-content: center;
		line-height: 1;

		&.warn {
			background-color: #f0ad4e;
			color: white;
			border-color: #f0ad4e;
		}
	}

	.filter {
		border-bottom: 1px solid #e5e5e5;
		padding-bottom: 1rem;
		padding-top: 0.5rem;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;

		.date {
			display: flex;
			align-items: center;
		}

		.vx-input-group .vx-input-group-default .vs-input {
			width: 150px;
		}

		.vx-input-group {
			margin-right: 20px;
		}

		.search .vs-icon {
			height: 100%;
			width: 35px;
			background: $primary;
			position: absolute;
			top: 0;
			right: 0;
			color: white !important;
			display: flex;
			align-items: center;
			justify-content: center;
			border-top-right-radius: 4px;
			border-bottom-right-radius: 4px;
			font-size: 22px;
		}

		.search .vs-con-input-label {
			width: 270px;
		}
	}
}

.con-exemple-prompt {
	.append-text {
		height: 2.7rem;
	}

	.vs-button {
		border-left: 0;
	}

	.vx-input-group-append {
		align-items: flex-end;
	}

	.vs-input {
		width: 100%;

		textarea {
			resize: none;
		}
	}
}

.viewTask {
	.vs-popup--title h3 {
		color: $primary;
	}

	.vs-popup--content {
		padding: 0;
	}

	table {
		width: 100%;

		td {
			padding-bottom: 4px;
		}
	}

	.body {
		padding: 1rem;

		table {
			margin-left: -2px;
		}

		p {
			padding-top: 10px;
			font-size: rem(14px);
		}
	}

	.footer {
		border-top: 1px solid rgba(0, 0, 0, 0.05);
		padding: 0.5rem 1rem;
		display: flex;
		justify-content: flex-end;

		button {
			margin-left: 10px;
		}
	}
}

.td {
  &.disabled {
    .task {
      opacity: 0.5;
      pointer-events: none;
    }
  }
}

.chat {
  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }
}

.delete-action {
  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }
}
</style>
